module.exports = __webpack_public_path__ + "static/img/menu.0b443b8.png";